import { action } from 'satcheljs/lib/legacy';
import ComposeViewState from '../store/schema/ComposeViewState';
import ImportanceType from 'owa-service/lib/contract/ImportanceType';
import datapoints from '../datapoints';

export default action('setImportance', datapoints.ComposeCommandSetImportance)(
    function setImportance(viewState: ComposeViewState, importance: ImportanceType) {
        viewState.importance = importance;
    }
);
